export const initialState = () => ({
    isPending: false,
    data: {
        slug: null,
        results: [],
    },
    error: null,
});

export default function category(state = initialState(), action) {
    return state;
}
